// import React, { useContext, useEffect } from 'react'
import React, { useContext, useEffect, useState } from 'react'

import { graphql, Link } from 'gatsby'

import { Helmet } from 'react-helmet'
import { Trans } from 'gatsby-plugin-react-i18next'

import {
  CAL_BUY_LINK,
  IS_FOREIGN_COUNTRY,
  IN_CA,
  SEASONAL_STATES,
  CURRENT_SEASONAL_STATE,
  VIP_CODE,
  LOCALIZATION,
  IN_SEASONAL_STATE,
  COUNTDOWN_EXPIRATIONS,
} from 'src/utils/constants'

import PropTypes from 'prop-types'
import fitsYourSpace from 'src/gifs/introducing-cal-max.gif'
import CalMaxHero from '../components/CalMaxHero'
import StoreContext from '../context/StoreContext'
import FAQs from '../components/FAQs'
import SEO from '../components/seo'
// import CountDownTimer from '../components/CountDownTimer'
import SeasonalCountdownTimer from '../components/SeasonalCountdownTimer'
import { CenteredContent, BuyNowLink } from '../components/Hero/styles'
import { ContentContainer, HideOverflow } from '../utils/styles/global-styles'
import Analytics from '../utils/Analytics'
import CalendarPress from '../components/CalendarPress'
import CalendarMatrix from '../components/CalendarMatrix'
import CalendarGuarantee from '../components/CalendarGuarantee'
import RedesignCalendarTestimonials from '../components/RedesignCalendarTestimonials'
import CalendarNewFeatures from '../components/CalendarNewFeatures'
import Quiz from '../components/Quiz'
import {
  MaxContainer,
  CtaContainer,
  BuyNowLinkCTA,
  Flexbox,
} from '../components/HomepageProducts/styles'
import { CalTitle, Text } from '../components/CalendarNewFeatures/styles'

const CalendarPage = ({ data: { calendarOgImage, countdown } }) => {
  // const CalendarPage = ({ data: { calendarOgImage } }) => {
  const [isCountdownVisible, setIsCountdownVisible] = useState(false)

  const {
    store: { updateBanner, banner },
    checkUtmParamsForPromo,
  } = useContext(StoreContext)

  // const { t } = useTranslation('calendar') // Removed due to only translating en to en - no real translations found
  const isVIPState = banner?.promoCode === VIP_CODE && !IN_SEASONAL_STATE
  const countdownData = IN_SEASONAL_STATE
    ? COUNTDOWN_EXPIRATIONS?.bfcm
    : countdown?.edges?.[0]?.node

  const country = `${LOCALIZATION}_countdown`
  const vipHolidayDate = isVIPState ? COUNTDOWN_EXPIRATIONS?.vip?.[country] : null
  const holidayDate = vipHolidayDate ?? (countdownData?.[country] || countdownData?.en_countdown)

  useEffect(() => {
    Analytics.track('Viewed Calendar Landing Page')

    let url = window.location.href

    if (url.endsWith('/')) {
      url = url.slice(0, -1)
    }

    const urlParams = new URLSearchParams(new URL(url).search)
    const utmTerm = urlParams.get('utm_term')

    if (utmTerm && utmTerm.toUpperCase() === 'LD30') {
      const channel = 'PR'
      const amount = '30'
      updateBanner('LD30', channel, amount)
    } else {
      checkUtmParamsForPromo(window.location.search)
    }
    if (holidayDate && holidayDate !== 'NONE') {
      setIsCountdownVisible(true)
    }
  }, [updateBanner, holidayDate])

  const handleOnCountdownComplete = () => {
    setIsCountdownVisible(false)
  }

  const renderCountdown = (currHolidayDate) => {
    const { bfcmCore, vip } = SEASONAL_STATES
    if (IN_SEASONAL_STATE) {
      return (
        <SeasonalCountdownTimer
          holidayDate={currHolidayDate}
          holidayState={CURRENT_SEASONAL_STATE ?? bfcmCore}
          onCountdownComplete={handleOnCountdownComplete}
        />
      )
    }

    const { promoCode } = banner
    if (promoCode === VIP_CODE) {
      return (
        <SeasonalCountdownTimer
          holidayDate={currHolidayDate}
          holidayState={vip}
          onCountdownComplete={handleOnCountdownComplete}
        />
      )
    }
  }

  return (
    <>
      <SEO
        title="Skylight Calendar | Smart Family Calendar"
        description="Skylight Calendar is a smart, touchscreen wall calendar that keeps track of your family’s schedule, chores, meal prep, and more all in one place! Staying on top of everything just got a whole lot easier."
        imagePath={calendarOgImage.childImageSharp.gatsbyImageData.images.fallback.src}
        path="/calendar/"
        canonicalPath="/calendar/"
      />
      <Helmet>
        <meta charset="UTF-8" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
        />
      </Helmet>
      <CalMaxHero calendar />
      {/* {IN_UK && isCountdownVisible && (
        <CountDownTimer
          holidayDate={holidayDate}
          page="bts"
          ctaLinkOverride={CAL_BUY_LINK}
          onCountdownComplete={handleOnCountdownComplete}
        />
      )} */}
      {isCountdownVisible && renderCountdown(holidayDate)}
      <HideOverflow>
        <RedesignCalendarTestimonials />
      </HideOverflow>
      {IN_CA && (
        <MaxContainer>
          <Flexbox>
            <CalTitle>Introducing Calendar Max ✨</CalTitle>
            <Text>
              Simplify your busy household and experience all the beloved features of our 10" and
              15" Calendars unified in one expansive, high-resolution display, tailor-made for
              dynamic family life.
            </Text>
            <CtaContainer>
              <Link to="/products/skylight-calendar-max/">
                <BuyNowLinkCTA>Buy Now</BuyNowLinkCTA>
              </Link>
            </CtaContainer>
          </Flexbox>
          <img src={fitsYourSpace} alt="Skylight Calendar turns into a screensaver" width="100%" />
        </MaxContainer>
      )}
      <CalendarNewFeatures />
      <CalendarGuarantee
        first
        ctaText={IS_FOREIGN_COUNTRY ? 'Buy Now' : 'Learn more'}
        ctaLink={
          IS_FOREIGN_COUNTRY
            ? CAL_BUY_LINK
            : 'https://skylight.zendesk.com/hc/en-us/articles/360043182612-Refund-and-Return-Policy'
        }
      />
      {!IN_SEASONAL_STATE && !IS_FOREIGN_COUNTRY && <Quiz hideImage calendar />}
      <CalendarPress />
      <CalendarMatrix />
      <FAQs page="calendar" />
      <ContentContainer>
        <CenteredContent>
          <BuyNowLink to={CAL_BUY_LINK}>
            <Trans>Buy Now</Trans>
          </BuyNowLink>
        </CenteredContent>
      </ContentContainer>
    </>
  )
}

CalendarPage.propTypes = {
  data: PropTypes.shape({
    calendarOgImage: PropTypes.object.isRequired,
    countdown: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            de_countdown: PropTypes.string,
            en_au_countdown: PropTypes.string,
            en_ca_countdown: PropTypes.string,
            en_countdown: PropTypes.string,
            en_gb_countdown: PropTypes.string,
          }),
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
}

export default CalendarPage

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["common", "calendar"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    calendarOgImage: file(relativePath: { eq: "meta-seo/calendar-products-logo.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    countdown: allContentfulCountdownTimer {
      edges {
        node {
          en_au_countdown
          en_ca_countdown
          en_countdown
          en_gb_countdown
        }
      }
    }
  }
`
